import { type FC, useState } from "react";
import { type UserInformation } from "@root/clientFrontend/features/scout/types";
import { useSWRData } from "@root/shared/hooks/useSWRData";
import { sendErrorLog } from "@root/shared/utils/sendErrorLog";
import { Loading } from "@clientFrontend/features/scout/components/Loading";
import { Presentation } from "./Presentation";

type Props = {
  fetchUrl?: string;
  userInformation?: UserInformation;
  userStatus?: {
    userId: string;
    isChecked: boolean;
  };
  handleChangeCheckbox?: (value: string) => void;
  isShadow?: boolean;
  isShowScoutNavigation: boolean;
  isShowCheckbox?: boolean;
  isDisabled?: boolean;
  isHiddenInitialValue?: boolean;
  hiddenScoutUrl?: string;
};

type ResponseProps = {
  data: UserInformation;
};

export const UserCassette: FC<Props> = ({
  fetchUrl,
  userInformation,
  userStatus,
  handleChangeCheckbox,
  isShadow = true,
  isShowScoutNavigation,
  isShowCheckbox,
  isDisabled,
  isHiddenInitialValue,
  hiddenScoutUrl,
}) => {
  const { data } = useSWRData<ResponseProps>({
    url: fetchUrl || null,
    options: {
      onError: (error: Error) => {
        sendErrorLog(new Error(error.message || "求職者のデータを取得できませんでした"));
      },
    },
  });
  const [isShow, setIsShow] = useState(false);
  const [isShowPopOver, setIsShowPopOver] = useState(false);
  const items = fetchUrl ? data : { data: userInformation };

  if (!items?.data)
    return (
      // TODO: ローディング要素のデザインコンポーネントが出来次第
      // 汎用ローディングコンポーネントを作成して置き換える
      <Loading isShadow={isShadow} />
    );

  const handleClose = () => {
    setIsShow(false);
    document.body.style.overflow = "";
  };
  const handleClick = () => {
    setIsShow(true);
    document.body.style.overflow = "hidden";
  };

  const handleClickPopOver = () => {
    setIsShowPopOver(!isShowPopOver);
  };

  return (
    <Presentation
      userInformation={items.data}
      isShowScoutNavigation={isShowScoutNavigation}
      isShowCheckbox={isShowCheckbox}
      isShow={isShow}
      onClose={handleClose}
      onClick={handleClick}
      userStatus={userStatus}
      handleChangeCheckbox={handleChangeCheckbox}
      isShadow={isShadow}
      isDisabled={isDisabled}
      isShowPopOver={isShowPopOver}
      handleClickPopOver={handleClickPopOver}
      isHiddenInitialValue={isHiddenInitialValue}
      hiddenScoutUrl={hiddenScoutUrl}
    />
  );
};
